import {
  jb_icon_css_default
} from "./chunk.I3N6I7TN.js";
import {
  iconNames
} from "./chunk.KZVW5BJQ.js";
import {
  o
} from "./chunk.DJ2G5F2M.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  Icon
} from "./chunk.4CJNI2ZH.js";
import {
  CommonAnimations
} from "./chunk.AHMM4X2O.js";
import {
  fetchWithCache,
  querySelectorAllShadow,
  smoothScroll
} from "./chunk.JTCOOS2A.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  n,
  r2 as r
} from "./chunk.XW2RSTES.js";
import {
  f
} from "./chunk.775UL347.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// node_modules/.pnpm/@lit+task@1.0.3/node_modules/@lit/task/task.js
var i2 = /* @__PURE__ */ Symbol();
var h = class {
  get taskComplete() {
    return this.t || (1 === this.i ? this.t = new Promise(((t, s2) => {
      this.o = t, this.h = s2;
    })) : 3 === this.i ? this.t = Promise.reject(this.l) : this.t = Promise.resolve(this.u)), this.t;
  }
  constructor(t, s2, i3) {
    this.p = 0, this.i = 0, (this._ = t).addController(this);
    const h2 = "object" == typeof s2 ? s2 : { task: s2, args: i3 };
    this.v = h2.task, this.j = h2.args, this.m = h2.argsEqual ?? r2, this.k = h2.onComplete, this.A = h2.onError, this.autoRun = h2.autoRun ?? true, "initialValue" in h2 && (this.u = h2.initialValue, this.i = 2, this.O = this.T?.());
  }
  hostUpdate() {
    true === this.autoRun && this.S();
  }
  hostUpdated() {
    "afterUpdate" === this.autoRun && this.S();
  }
  T() {
    if (void 0 === this.j) return;
    const t = this.j();
    if (!Array.isArray(t)) throw Error("The args function must return an array");
    return t;
  }
  async S() {
    const t = this.T(), s2 = this.O;
    this.O = t, t === s2 || void 0 === t || void 0 !== s2 && this.m(s2, t) || await this.run(t);
  }
  async run(t) {
    let s2, h2;
    t ??= this.T(), this.O = t, 1 === this.i ? this.q?.abort() : (this.t = void 0, this.o = void 0, this.h = void 0), this.i = 1, "afterUpdate" === this.autoRun ? queueMicrotask((() => this._.requestUpdate())) : this._.requestUpdate();
    const r3 = ++this.p;
    this.q = new AbortController();
    let e = false;
    try {
      s2 = await this.v(t, { signal: this.q.signal });
    } catch (t2) {
      e = true, h2 = t2;
    }
    if (this.p === r3) {
      if (s2 === i2) this.i = 0;
      else {
        if (false === e) {
          try {
            this.k?.(s2);
          } catch {
          }
          this.i = 2, this.o?.(s2);
        } else {
          try {
            this.A?.(h2);
          } catch {
          }
          this.i = 3, this.h?.(h2);
        }
        this.u = s2, this.l = h2;
      }
      this._.requestUpdate();
    }
  }
  abort(t) {
    1 === this.i && this.q?.abort(t);
  }
  get value() {
    return this.u;
  }
  get error() {
    return this.l;
  }
  get status() {
    return this.i;
  }
  render(t) {
    switch (this.i) {
      case 0:
        return t.initial?.();
      case 1:
        return t.pending?.();
      case 2:
        return t.complete?.(this.value);
      case 3:
        return t.error?.(this.error);
      default:
        throw Error("Unexpected status: " + this.i);
    }
  }
};
var r2 = (s2, i3) => s2 === i3 || s2.length === i3.length && s2.every(((s3, h2) => !f(s3, i3[h2])));

// src/mixins/Linkable.ts
var LinkableEvents = class {
  constructor() {
    this["jb-link:clicked"] = void 0;
    this["jb-link:initialized"] = void 0;
  }
};
function registerLinkClickHandlers(linkTag, linkableComponent = void 0) {
  linkTag.addEventListener("click", (clickEvent) => {
    const textContent = linkableComponent?.getTextContent?.() ?? linkTag.innerText;
    const detail = { linkTag, clickEvent, linkableComponent, textContent, noGenericLinkTracking: false };
    if (linkTag.dataset.jblinkdata !== void 0) {
      const jblinkdata = JSON.parse(linkTag.dataset.jblinkdata);
      Object.assign(detail, jblinkdata);
    }
    if (linkableComponent?.link?.href && linkableComponent?.link?.href !== "#") {
      const linkFragment = linkableComponent.link.href.split("#")[1];
      if (typeof linkFragment !== "undefined") {
        const targets = querySelectorAllShadow(`#${linkFragment}`);
        if (targets.length === 1) {
          smoothScroll(targets[0]);
        }
      }
    }
    const customEvent = new CustomEvent("jb-link:clicked", {
      detail: {
        ...detail,
        trigger: "Linkable"
      },
      bubbles: true,
      composed: true
    });
    clickEvent.target?.dispatchEvent(customEvent);
  });
}
function jbLinkClickedEventToJbTrackingEvent(jbLinkClickedEvent, preconfiguredDetails) {
  const { type, linkTag } = jbLinkClickedEvent.detail;
  let trackingType;
  if (jbLinkClickedEvent.detail.contactOverlayForm) {
    trackingType = "contactOverlay";
  } else if (jbLinkClickedEvent.detail.publicationOverlay) {
    trackingType = "publicationDownloadOverlay";
  } else if (jbLinkClickedEvent.detail.cookieSettings) {
    trackingType = "cookieSettings";
  } else {
    trackingType = type || "internal";
  }
  let detail;
  switch (trackingType) {
    case "contactOverlay":
      detail = {
        event: "ce_interaction",
        interaction_effect: "open",
        interaction_element: "Overlay Links",
        interaction_result: `Contact | ${jbLinkClickedEvent.detail.contactFormUid}`,
        interaction_type: "click"
      };
      break;
    case "download":
      detail = {
        event: "ce_download",
        file_name: jbLinkClickedEvent.detail.downloadFileName.split(".").shift(),
        file_type: jbLinkClickedEvent.detail.downloadFileName.split(".").pop().toLocaleLowerCase()
      };
      break;
    case "external":
    case "in-page":
    case "internal":
      detail = {
        event: "ce_interaction",
        interaction_effect: "navigation",
        interaction_element: type === "external" ? "External Links" : "Internal Links",
        interaction_result: new URL(linkTag.href).href,
        interaction_type: "click"
      };
      break;
    case "social":
      detail = {
        event: "ce_interaction",
        interaction_effect: "navigation",
        interaction_element: "Social Links",
        interaction_result: new URL(linkTag.href).href,
        interaction_type: "click"
      };
      break;
    case "publicationDownloadOverlay":
      detail = {
        event: "ce_interaction",
        interaction_effect: "open",
        interaction_element: "Overlay Links",
        interaction_result: `Download | ${jbLinkClickedEvent.detail.publicationOverlay.texts.downloadSuccessTitle}`,
        interaction_type: "click"
      };
      break;
    default:
      return;
  }
  jbLinkClickedEvent.stopPropagation();
  document.body.dispatchEvent(
    new CustomEvent("jb-link:clicked", {
      detail: {
        ...jbLinkClickedEvent.detail,
        noGenericLinkTracking: true
      },
      bubbles: true,
      composed: true
    })
  );
  return new CustomEvent("jb-tracking", {
    detail: {
      interaction_text: jbLinkClickedEvent.detail.textContent,
      ...detail,
      ...preconfiguredDetails,
      event_version: "v2"
    },
    bubbles: true,
    composed: true
  });
}
function initializeLink(linkTag, linkableComponent = void 0) {
  if (!linkTag) {
    return;
  }
  if (!linkTag.dataset.linkInitialized) {
    registerLinkClickHandlers(linkTag, linkableComponent);
  }
  linkTag.dataset.linkInitialized = "true";
  const customEvent = new CustomEvent("jb-link:initialized", {
    bubbles: true,
    composed: true,
    detail: { ...JSON.parse(linkTag.dataset.jblinkdata || "{}"), linkTag, linkableComponent }
  });
  linkTag.dispatchEvent(customEvent);
}
function setLinkAttributes(element, link) {
  if (!element || !link) {
    return;
  }
  const { data, download, href, marketUris, name, target } = link;
  element.setAttribute("href", href || "#");
  if (marketUris) {
    element.setAttribute("data-market-uris", JSON.stringify(marketUris));
  } else {
    element.removeAttribute("data-market-uris");
  }
  if (name) {
    element.setAttribute("name", name);
  } else {
    element.removeAttribute("name");
  }
  if (download) {
    element.setAttribute("download", "");
  } else {
    element.removeAttribute("download");
  }
  if (target) {
    element.setAttribute("target", target);
  } else {
    element.removeAttribute("target");
  }
  if (data) {
    element.setAttribute("data-jblinkdata", JSON.stringify(data));
  } else {
    element.removeAttribute("data-jblinkdata");
  }
}
function setLink(element, link) {
  setLinkAttributes(element, link);
  initializeLink(element);
}
function getLinkIcon(type) {
  if (type === "mail") {
    return b`<jb-icon iconName="material:mail"></jb-icon>`;
  }
  if (type === "download") {
    return b`<jb-icon iconName="material:download"></jb-icon>`;
  }
  if (type === "in-page") {
    return b`<jb-icon iconName="material:north"></jb-icon>`;
  }
  if (type === "internal") {
    return b`<jb-icon iconName="material:east"></jb-icon>`;
  }
  if (type === "external") {
    return b`<jb-icon iconName="material:open_in_new"></jb-icon>`;
  }
  return "";
}
function getLinkIconName(type) {
  if (type === "mail") return "material:mail";
  if (type === "download") return "material:download";
  if (type === "in-page") return "material:south";
  if (type === "internal") return "material:east";
  if (type === "external") return "material:open_in_new";
  if (iconNames.includes(type)) return type;
  return void 0;
}
function Linkable(baseClass) {
  class LinkableMixin extends baseClass {
    update(changedProperties) {
      super.update(changedProperties);
      if (changedProperties.has("link")) {
        this._linkTags?.forEach((linkTag) => {
          setLinkAttributes(linkTag, this.link);
          initializeLink(linkTag, this);
        });
      }
    }
    getTextContent() {
      return null;
    }
    /**
     * Override this method in your web component if you want to define default link values.
     * { target: '_blank' } will make your link open in a new window, if the link data don't explicitly set a different target
     * { download: true } will set a download attribute on your link, if the link data don't explicitly set it to false
     */
    _getLinkDefaultValues() {
      return {};
    }
  }
  __decorateClass([
    n({ type: Object })
  ], LinkableMixin.prototype, "link", 2);
  __decorateClass([
    r("a[data-linkable]")
  ], LinkableMixin.prototype, "_linkTags", 2);
  return LinkableMixin;
}

// src/components/jb-icon/jb-icon.ts
var JbIcon = class extends CommonAnimations(Icon(i)) {
  constructor() {
    super(...arguments);
    this.size = "regular";
    this._cssTask = new h(this, {
      task: async ([iconName]) => {
        if (!iconName) return null;
        if (this._iconLibrary !== "animated") return null;
        const svgPath = this._svgPath;
        if (svgPath === "") return null;
        const cssPath = svgPath.replace(".svg", ".css");
        return fetchWithCache(cssPath, "CSS", this._cacheVersion, "text/css");
      },
      args: () => [this._svgTask.value]
    });
    this._pathPrefix = "";
    this._svgTask = new h(this, {
      task: async ([iconName, rawSVG]) => {
        if (rawSVG) return rawSVG;
        if (!iconName) return "";
        const svgPath = this._svgPath;
        if (svgPath === "") return "";
        return fetchWithCache(svgPath, "icon", this._cacheVersion, "image/svg+xml");
      },
      args: () => [this.iconName, this.rawSVG, this.size, this.weight]
    });
  }
  connectedCallback() {
    super.connectedCallback();
    this._pathPrefix = document.body.dataset.assetLibrary ?? "";
    this._cacheVersion = document.body.dataset.iconCacheVersion;
  }
  get _iconLibrary() {
    if (!this.iconName) return null;
    const nameArray = this.iconName.split(":");
    return nameArray[1] ? nameArray[0] : "material";
  }
  get _parsedIconName() {
    if (!this.iconName) return "";
    const nameArray = this.iconName.split(":");
    return nameArray[1] ?? this.iconName;
  }
  get _svgPath() {
    const library = this._iconLibrary;
    const iconName = this._parsedIconName;
    switch (library) {
      case "material": {
        const sizes = {
          small: 500,
          regular: 400,
          large: 300,
          20: 500,
          24: 400,
          32: 400,
          48: 300
        };
        const weight = sizes[this.size ?? 400] + (this.weight === "bold" ? 100 : 0);
        return `${this._pathPrefix}/icons/material/${weight}/rounded/${iconName}.svg`;
      }
      case "proprietary":
        return `${this._pathPrefix}/icons/proprietary/${iconName}.svg`;
      case "custom": {
        const weight = this.size === "large" ? "normal" : "bold";
        return `${this._pathPrefix}/icons/custom/${weight}/${iconName}.svg`;
      }
      case "animated": {
        const weight = this.size === "large" ? "normal" : "bold";
        return `${this._pathPrefix}/icons/animated/${weight}/${iconName}.svg`;
      }
      default:
        return "";
    }
  }
  render() {
    return b`
      ${this._cssTask.render({
      pending: () => A,
      complete: (css) => css ? b`<style>
                ${css}
              </style>` : A,
      error: (error) => {
        const errorMsg = error instanceof Error ? error.message : String(error);
        return o(`<!-- Error loading CSS: ${errorMsg} -->`);
      }
    })}
      ${this._iconLibrary === "material" ? b`<style>
              svg {
                fill: currentColor;
              }
            </style>` : A}
      ${this._svgTask.render({
      pending: () => A,
      complete: (svgContent) => b`${o(svgContent)}`,
      error: (error) => {
        const errorMsg = error instanceof Error ? error.message : String(error);
        return o(`<!-- Error loading SVG: ${errorMsg} -->`);
      }
    })}
    `;
  }
};
JbIcon.styles = jb_icon_css_default;
__decorateClass([
  n()
], JbIcon.prototype, "iconName", 2);
__decorateClass([
  n()
], JbIcon.prototype, "rawSVG", 2);
__decorateClass([
  n({ reflect: true })
], JbIcon.prototype, "size", 2);
__decorateClass([
  n()
], JbIcon.prototype, "weight", 2);
JbIcon = __decorateClass([
  customElement("jb-icon")
], JbIcon);

export {
  h,
  JbIcon,
  LinkableEvents,
  jbLinkClickedEventToJbTrackingEvent,
  initializeLink,
  setLink,
  getLinkIcon,
  getLinkIconName,
  Linkable
};
/*! Bundled license information:

@lit/task/task.js:
  (**
   * @license
   * Copyright 2017 Google LLC
   * SPDX-License-Identifier: BSD-3-Clause
   *)
*/
